











import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Flashcard extends Vue {
    @Prop() private name!: string;
    @Prop() private basedir!: string;
    @Prop() private ribbon!: boolean;
    private flipped: boolean = false;
    flip () {
        this.flipped = !this.flipped;
    }
}
